export default {
  baseStyle: {
    content: {
      borderColor: 'greys.200',
      boxShadow: 'lg',
    },
  },
  variants: {
    responsive: {
      content: {
        width: 'unset',
      },
    },
  },
}
